/* ==========================================================
   LINK "RASTREAR PEDIDO" NO HEADER
   - Adiciona um link no header (ao lado de Iniciar Sesión)
   - Clica -> faz scroll suave até a section de rastreio
   - Foca o input do código automaticamente
   ========================================================== */
(function () {
  'use strict';

  var LINK_ID = 'bs-header-tracking-link';

  function injectLink() {
    if (document.getElementById(LINK_ID)) return;

    var headerRight = document.querySelector('.bs-header-right');
    if (!headerRight) return;

    // Cria o link
    var link = document.createElement('a');
    link.id = LINK_ID;
    link.href = '#bs-tracking-section';
    link.className = 'bs-icon-link bs-header-tracking-link';
    link.innerHTML = '<span class="bs-tracking-link-icon">📦</span><span class="bs-tracking-link-text">Rastrear Pedido</span>';

    // Insere ANTES do "Iniciar Sesión" (primeiro filho do header-right)
    headerRight.insertBefore(link, headerRight.firstChild);

    link.addEventListener('click', function (e) {
      e.preventDefault();
      scrollToTracking();
    });
  }

  function scrollToTracking() {
    var section = document.getElementById('bs-tracking-section');
    if (!section) {
      // Se não existe (ex: outras páginas), vai pra home + scroll
      window.location.href = '/#bs-tracking-section';
      return;
    }

    // Scroll suave até a section
    var headerHeight = 100;
    var top = section.getBoundingClientRect().top + window.pageYOffset - headerHeight;
    window.scrollTo({ top: top, behavior: 'smooth' });

    // Foca o input depois do scroll
    setTimeout(function () {
      var input = document.getElementById('bsTrackingInput');
      if (input) {
        input.focus();
        // Pequena animação de destaque
        input.classList.add('bs-tracking-input--highlight');
        setTimeout(function () { input.classList.remove('bs-tracking-input--highlight'); }, 1800);
      }
    }, 700);
  }

  // Verifica hash na URL ao carregar (ex: vindo de outra página)
  function handleHash() {
    if (window.location.hash === '#bs-tracking-section') {
      setTimeout(scrollToTracking, 400);
    }
  }

  function run() {
    try { injectLink(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); handleHash(); });
  } else {
    run();
    handleHash();
  }
  [300, 1000, 2500].forEach(function (ms) { setTimeout(run, ms); });
})();
